/**
 * Calls the BFF `releaseOutboundLeadTask` mutation to unassign a Speed-to-Lead task
 * (clears sys.assigned_to and resets sys.status to to_do in Task Hub).
 *
 * Called from two places:
 *  - acceptanceExpiry.ts: when the 60-second acceptance window expires without
 *    the CSR dialling (task returned to the pool automatically)
 *  - Future: task 4d pre-dial release (inbound call offered / CSR goes offline)
 *
 * Error handling: this function lets errors propagate to the caller. Both call
 * sites catch the error, log it, and proceed with local cleanup regardless —
 * the BFF cron job (task 4b) is the authoritative safety net for any release
 * that fails here.
 */
import { getClient } from '@api/client';
import { graphql } from '@api/generated';
import { MutationReleaseOutboundLeadTaskArgs } from '@api/generated/graphql';

export const RELEASE_OUTBOUND_LEAD_TASK_MUTATION = graphql(`
  mutation ReleaseOutboundLeadTask($tenantId: ID!, $taskId: ID!) {
    releaseOutboundLeadTask(tenantId: $tenantId, taskId: $taskId)
  }
`);

export const releaseTask = async (
  variables: MutationReleaseOutboundLeadTaskArgs,
): Promise<boolean> => {
  const { data } = await getClient().mutate({
    mutation: RELEASE_OUTBOUND_LEAD_TASK_MUTATION,
    variables,
  });

  return data?.releaseOutboundLeadTask ?? false;
};
